export default __webpack_public_path__ + "static/media/quiz-walkthrough-bg.0f640c9c.svg";